module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Abbie Brown: On the Cusp")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004"
    }
  }, [_vm._v("April")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-72-kgs-single."
    }
  }, [_vm._v("5th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-72-kgs-single.-1"
    }
  }, [_vm._v("8th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-weight-unknown-no-scales-in-santorini-hotel-suite.-still-single."
    }
  }, [_vm._v("10th April. Weight unknown – No scales in Santorini hotel suite. Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-weight-unknown-still-33.-still-single."
    }
  }, [_vm._v("12th April. Weight unknown – Still 33. Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-weight-a-mystery-but-i-dont-care-still-single."
    }
  }, [_vm._v("13th April. Weight a mystery but I don’t care – Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-santorini.-weight-unknown-still-single."
    }
  }, [_vm._v("16th April. Santorini. Weight unknown – Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-london-shock-horror-75-kgs-and-still-single."
    }
  }, [_vm._v("18th April. London – Shock, horror, 75 kgs and still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#th-april.-75-kgs-single."
    }
  }, [_vm._v("20th April. 75 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#rd-april.-75-kgs-34-and-single."
    }
  }, [_vm._v("23rd April. 75 kgs – 34 and single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-74-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5th May. 74 kgs – Single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-74-kgs-single-minor-celebrity.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7th May. 74 kgs – Single – Minor Celebrity.")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single-a-photographers-dream.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th May. 73 kgs – Single – A photographer’s dream.")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single-fighting-off-admirers.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12th May. 73 kgs – Single – Fighting off admirers.")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#rd-may.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#th-may.-73-kgs-single.-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29th May. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#st-may.-73-kg-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31st May. 73 Kg – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#rd-june.-72-kgs-single.-consumed-by-guilt.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3rd June. 72 kgs – single. Consumed by guilt.")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-71-kgs-single.-down-2-kgs.-consuming-nothing-but-guilt.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6th June. 71 kgs – single. Down 2 kgs. Consuming nothing but guilt.")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-71-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8th June. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-71-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18th June. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-71-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20th June. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-71-kgs-single.-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th June. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#th-june.-72-kgs-still-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30th June. 72 kgs – Still single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("July")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#th-july.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5th July. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#th-july.-72-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8th July. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#th-july.-72-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th July. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#th-july.-72-kgs-glad-to-be-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th July. 72 kgs – Glad to be single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#th-august.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7th August. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#th-august.-72-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th August. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#th-august.-72-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24th August. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#th-august.-71-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28th August. 71 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("September")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#th-september.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4th September. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#th-september.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5th September. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#th-september.-74-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17th September. 74 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#rd-september.-74-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd September. 74 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("October")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#nd-october.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22nd October. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#rd-october.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd October. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#th-october.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28th October. 73 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("November")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5th November. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-73-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6th November. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-73-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th November. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th November. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-72-kgs-single-and-seriously-encumbered.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18th November. 72 kgs – Single and seriously encumbered.")])]), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#th-november.-72-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20th November. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#nd-november.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22nd November. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#rd-november.-72-kgs-single-and-mercifully-unencumbered.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd November. 72 kgs – single and mercifully unencumbered.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("December")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#th-december.-70-kgs-single.-still-looking.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th December. 70 kgs – single. Still looking.")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#st-december.-70-kgs-single-but-have-found-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21st December. 70 kgs – Single but have found love!")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#rd-december.-72-kgs-single-dog-owner.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd December. 72 kgs – single dog owner.")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#th-december.-72-kgs-dog-owner-still-single-just.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th December. 72 kgs – Dog owner – Still single – just.")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#th-december.-73-kgs-dog-owner-and-chronically-single",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27th December. 73 kgs – Dog owner and chronically single…")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#th-december.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29th December. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#st-december.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31st December. 73 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("January")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-72-kgs-single.-on-the-move.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th January. 72 kgs – single. On the move.")])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-down-on-the-farm.-weight-unknown-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12th January. Down on the farm. Weight unknown – Single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-weight-unknown-still-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13th January. Weight unknown – Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-weight-unknown.-still-single-but-you-never-know.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14th January. Weight unknown. Still single – but you never know.")])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-weight-unknown-single-but-attracting-a-lot-of-attention-from-ralph",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th January. Weight unknown – Single but attracting a lot of attention from Ralph!")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-weight-unknown-single.-wherefore-art-thou-ralph",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16th January. Weight unknown – single. Wherefore art thou – Ralph?")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-yikes-76-kgs-still-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17th January. Yikes! 76 kgs – Still single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#th-january.-single-dont-dare-consult-the-scales.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20"), _c('sup', [_vm._v("th")]), _vm._v(" January. Single – Don’t dare consult the scales.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("February")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#nd-february.-75-kgs-single.-dog-owner-again.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2nd February. 75 kgs – single. Dog owner – again.")])]), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-75-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4th February. 75 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-75-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6th February. 75 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-74-kgs-single.-still-walking-the-dog.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8th February. 74 kgs – single. Still walking the dog.")])]), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th February. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-73-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14th February. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-73-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18th February. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-73-kgs-single.-no-longer-a-dog-owner.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20th February. 73 kgs – single. No longer a dog owner.")])]), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#nd-february.-73-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22nd February. 73 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#th-february.-73-kgs-single.-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27th February. 73 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("March")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#nd-march.-72-kgs-single.-art-lover.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2nd March. 72 kgs – single. Art Lover.")])]), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-71-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th March. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-71-kgs-single.-mental-stability",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th March. 71 kgs – single. Mental stability?")])]), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-70-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20th March. 70 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-70-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th March. 70 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-71-kgs-single.-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26th March. 71 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#th-march.-72-kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30th March. 72 kgs – single.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("April")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single-and-optimistic.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('sup', [_vm._v("th")]), _vm._v(" April. 72 kgs – Single and optimistic.")])]), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single.-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single.-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72kgs-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15th April. 72kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-weight-unknown-single-and-i-dont-care.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16th April. Weight unknown – single and I don’t care.")])]), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-weight-unknown-single.-festival-day-the-good-the-bad-and-the-ugly.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17th April. Weight unknown – single. Festival Day: The good, the bad and the ugly.")])]), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#rd-april.-71-kgs-35-still-single",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23rd April. 71 kgs 35 – Still Single")])]), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single.-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single.-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26th April. 72 kgs – single")])]), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-april.-72-kgs-single.-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28th April. 72 kgs – single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#rd-may.-weight-unknown.-dont-care.-single.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3rd May. Weight unknown. Don’t care. Single.")])]), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#th-may.-72-kgs-35-single-but-ever-hopeful.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10th May. 72 kgs – 35 – Single but ever hopeful.")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0